/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 1 = CMDLINE 2 = COMPRESSWHITESPACE 3 = CSSDECODE 4 = HEXENCODE 5 = HTMLENTITYDECODE 6 = JSDECODE 7 = LENGTH 8 = LOWERCASE 9 = MD5 10 = NORMALIZEPATH 11 = NORMALISEPATH 12 = NORMALIZEPATHWIN 13 = NORMALISEPATHWIN 14 = REMOVECOMMENTS 15 = REMOVENULLS 16 = REMOVEWHITESPACE 17 = REPLACECOMMENTS 18 = SHA1 19 = URLDECODE 20 = URLDECODEUNI 21 = UTF8TOUNICODE
 */
export type WafRuleTransformationType = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21;

export const WafRuleTransformationType = {
  CMDLINE: 1 as WafRuleTransformationType,
  COMPRESSWHITESPACE: 2 as WafRuleTransformationType,
  CSSDECODE: 3 as WafRuleTransformationType,
  HEXENCODE: 4 as WafRuleTransformationType,
  HTMLENTITYDECODE: 5 as WafRuleTransformationType,
  JSDECODE: 6 as WafRuleTransformationType,
  LENGTH: 7 as WafRuleTransformationType,
  LOWERCASE: 8 as WafRuleTransformationType,
  MD5: 9 as WafRuleTransformationType,
  NORMALIZEPATH: 10 as WafRuleTransformationType,
  NORMALISEPATH: 11 as WafRuleTransformationType,
  NORMALIZEPATHWIN: 12 as WafRuleTransformationType,
  NORMALISEPATHWIN: 13 as WafRuleTransformationType,
  REMOVECOMMENTS: 14 as WafRuleTransformationType,
  REMOVENULLS: 15 as WafRuleTransformationType,
  REMOVEWHITESPACE: 16 as WafRuleTransformationType,
  REPLACECOMMENTS: 17 as WafRuleTransformationType,
  SHA1: 18 as WafRuleTransformationType,
  URLDECODE: 19 as WafRuleTransformationType,
  URLDECODEUNI: 20 as WafRuleTransformationType,
  UTF8TOUNICODE: 21 as WafRuleTransformationType,
};
